export interface ClassicDefaults {
  birthdayClassSize: number;
  buffonNeedleLength: number;
  buffonLineSpacing: number;
}

export const CLASSIC_DEFAULTS: ClassicDefaults = {
  birthdayClassSize: 23,
  buffonNeedleLength: 1,
  buffonLineSpacing: 1,
};
